import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { HelpWidgetConversation } from "../types/help_widget_conversation";

interface CreateDraftConversationOptions {
  onError?: (error: { errorDetails: string }) => void;
  onSuccess?: (data: { id: string }) => void;
}

export const useCreateDraftConversation = ({
  onSuccess,
  onError,
}: CreateDraftConversationOptions = {}) =>
  useMutation({
    mutationFn: async (conversation: HelpWidgetConversation) =>
      reactQueryPost(
        internalApi.helpWidget.createConversationDraft({
          conversation: conversation,
        }),
      ),
    onSuccess,
    onError,
  });
